import Keycloak from "keycloak-js";

export const keycloakConfig = {
	url: import.meta.env.VITE_KEYCLOAK_URL,
	realm: import.meta.env.VITE_KEYCLOAK_REALM,
	clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
};

// Validate required configuration
if (!keycloakConfig.url || !keycloakConfig.realm || !keycloakConfig.clientId) {
	throw new Error(
		"Missing required Keycloak configuration. Please set VITE_KEYCLOAK_URL, VITE_KEYCLOAK_REALM, and VITE_KEYCLOAK_CLIENT_ID environment variables."
	);
}

export const keycloakInitOptions = {
	onLoad: "check-sso" as const,
	flow: "standard" as const,
	pkceMethod: "S256" as const, // PKCE with S256 provides CSRF protection
	silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
	silentCheckSsoFallback: true, // Fallback to redirect-based check-sso when silent check fails (Safari ITP, Firefox ETP)
	checkLoginIframe: false, // Disabled due to third-party cookie blocking in privacy-focused browsers (Brave, Firefox, Safari)
};

let keycloakInstance: Keycloak | null = null;

export function getKeycloak(): Keycloak {
	if (!keycloakInstance) {
		keycloakInstance = new Keycloak(keycloakConfig);
	}
	return keycloakInstance;
}
